module.exports = __webpack_public_path__ + "img/vpls.df232017.png";